import { WORK_REPORT_PUBLIC_PATH } from '../constants/work-reports.js';
/**
 * Pagine e endpoint PUBBLICI col token nel path: l'indirizzo è la chiave del
 * documento, quindi non deve finire in log, registro errori, Sentry o
 * registrazioni di sessione. Fonte unica per backend (log e telemetria) e
 * webapp (strumenti di analisi e Sentry).
 */
/** Pagina della webapp che apre la firma del contratto dal link dell'email. */
export const CONTRACT_SIGN_PUBLIC_PATH = '/contract';
/** Pagine della webapp col token nel segmento successivo al prefisso. */
export const PUBLIC_TOKEN_PAGE_PATHS = [
    WORK_REPORT_PUBLIC_PATH,
    CONTRACT_SIGN_PUBLIC_PATH,
];
/** Endpoint del backend (sotto `/api/v1`) col token nel segmento successivo. */
export const PUBLIC_TOKEN_API_PATHS = [
    '/public/work-reports',
    '/public/contracts',
];
/** Segnaposto del token nei testi redatti. */
export const REDACTED_TOKEN = '[REDACTED]';
const escapeForRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const PUBLIC_TOKEN_PREFIXES = [
    ...PUBLIC_TOKEN_API_PATHS,
    ...PUBLIC_TOKEN_PAGE_PATHS,
].map(escapeForRegExp);
/**
 * Prefisso pubblico seguito dal segmento del token, ovunque compaia nel
 * testo (URL assoluto, path relativo, messaggio di log). I prefissi iniziano
 * con `/` e sono seguiti da `/`: `/contract/` non è `/contracts/`.
 */
const PUBLIC_TOKEN_SEGMENT_PATTERN = new RegExp(`(${PUBLIC_TOKEN_PREFIXES.join('|')})/[^/?#\\s"'<>]+`, 'g');
/** Il testo con ogni token di un path pubblico sostituito da `[REDACTED]`. */
export function redactPublicTokenPaths(text) {
    return text.replace(PUBLIC_TOKEN_SEGMENT_PATTERN, (_match, prefix) => `${prefix}/${REDACTED_TOKEN}`);
}
/** Pagina della webapp col token nel path (link rapportino, firma contratto). */
export function isPublicTokenPagePath(pathname) {
    return PUBLIC_TOKEN_PAGE_PATHS.some((prefix) => pathname.startsWith(`${prefix}/`) && pathname.length > prefix.length + 1);
}
const isPlainObject = (value) => {
    if (value === null || typeof value !== 'object')
        return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
};
/**
 * Copia profonda di oggetti e array semplici con i token redatti in ogni
 * stringa (eventi Sentry: request, breadcrumb, transazione, span, messaggi).
 * Gli altri valori (date, errori, istanze) passano invariati.
 */
export function redactPublicTokensDeep(value) {
    if (typeof value === 'string')
        return redactPublicTokenPaths(value);
    if (Array.isArray(value)) {
        return value.map((item) => redactPublicTokensDeep(item));
    }
    if (isPlainObject(value)) {
        return Object.fromEntries(Object.entries(value).map(([key, item]) => [
            key,
            redactPublicTokensDeep(item),
        ]));
    }
    return value;
}
//# sourceMappingURL=public-token-paths.js.map